import React from "react";
import { Mutation } from "@apollo/client/react/components";
import history from "./../../history";

import { Formik, Form, Field } from "formik";
import { UserCreateValidationSchema } from "./UserValidationSchema";

import { CREATE_USER } from "./UserQueries";

const UserCreate = (props) => {
  const roles = props.roles;

  return (
    <div className="row">
      <div className="col-6">
        <Mutation mutation={CREATE_USER}>
          {(userCreate, { loading }) => (
            <Formik
              initialValues={{
                firstName: "",
                lastName: "",
                email: "",
                password: "",
                roleIDs: [],
              }}
              validateOnChange={true}
              validateOnBlur={true}
              validationSchema={UserCreateValidationSchema}
              onSubmit={async (
                values,
                { setSubmitting, setStatus, resetForm }
              ) => {
                setStatus(undefined);

                const results = await userCreate({
                  variables: {
                    ...values,
                    tenantID: parseInt(localStorage.defaultTenantID),
                  },
                });

                if (results.data.userCreate.errors.length > 0) {
                  const errors = results.data.userCreate.errors;

                  setStatus(
                    errors
                      .map((error) => {
                        return {
                          field: [error.field],
                          message: error.message,
                        };
                      })
                      .reduce((obj, value) => {
                        obj[value.field] = value.message;
                        return obj;
                      }, {})
                  );

                  setSubmitting(false);
                } else {
                  resetForm();
                  setSubmitting(false);

                  history.push(
                    `/settings/users?created_first=${encodeURIComponent(values.firstName)}&created_last=${encodeURIComponent(values.lastName)}`
                  );
                }
              }}
            >
              {({ errors, status, touched, isSubmitting, setFieldValue }) => (
                <Form>
                  <div className="form-group">
                    <label htmlFor="firstName">First Name</label>
                    <Field
                      id="firstName"
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      className="form-control"
                      autoComplete="given-name"
                    />

                    {status && status.firstName ? (
                      <div className="invalid-feedback d-block">
                        {status.firstName}
                      </div>
                    ) : (
                      errors.firstName &&
                      touched.firstName && (
                        <div className="invalid-feedback d-block">
                          {errors.firstName}
                        </div>
                      )
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <Field
                      id="lastName"
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      className="form-control"
                      autoComplete="family-name"
                    />

                    {status && status.lastName ? (
                      <div className="invalid-feedback d-block">
                        {status.lastName}
                      </div>
                    ) : (
                      errors.lastName &&
                      touched.lastName && (
                        <div className="invalid-feedback d-block">
                          {errors.lastName}
                        </div>
                      )
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <Field
                      id="email"
                      type="email"
                      name="email"
                      placeholder="Email"
                      className="form-control"
                      autoComplete="email"
                    />

                    {status && status.email ? (
                      <div className="invalid-feedback d-block">
                        {status.email}
                      </div>
                    ) : (
                      errors.email &&
                      touched.email && (
                        <div className="invalid-feedback d-block">
                          {errors.email}
                        </div>
                      )
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <Field
                      id="password"
                      type="password"
                      name="password"
                      placeholder="Password"
                      className="form-control"
                      autoComplete="new-password"
                    />
                    <small id="emailHelp" className="form-text text-muted">
                      Min. 8 characters
                    </small>
                    {status && status.password ? (
                      <div className="invalid-feedback d-block">
                        {status.password}
                      </div>
                    ) : (
                      errors.password &&
                      touched.password && (
                        <div className="invalid-feedback d-block">
                          {errors.password}
                        </div>
                      )
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="roleIDs">Roles</label>
                    <Field
                      id="roleIDs"
                      name="roleIDs"
                      component="select"
                      multiple={true}
                      className="form-control"
                      onChange={(event) =>
                        setFieldValue(
                          "roleIDs",
                          [...event.target.options]
                            .filter((o) => o.selected)
                            .map((o) => parseInt(o.value))
                        )
                      }
                    >
                      {roles.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                    </Field>

                    {status && status.roleIDs ? (
                      <div className="invalid-feedback d-block">
                        {status.roleIDs}
                      </div>
                    ) : (
                      errors.roleIDs &&
                      touched.roleIDs && (
                        <div className="invalid-feedback d-block">
                          {errors.roleIDs}
                        </div>
                      )
                    )}
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {loading ? "Creating New User..." : "Create User"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </Mutation>
      </div>
    </div>
  );
};

export default UserCreate;
